import React from 'react';
import ReactTooltip from 'react-tooltip';
import { preventNonNumericalInput, prevNonNumericalWithDec } from '../../../layouts/Operational_Sidebar_Progress.component';
import NfProductSearchSelect, { getProductOptionsForForm } from './NfProductSearchSelect.component';
import './NonFuelProductModal.css';

const NonFuelProductModal = ({
  rack_error,
  rack_error_single,
  isShowing,
  chek_rk,
  handle,
  err,
  er,
  handleAdd,
  double,
  handleRemove,
  handleDelete,
  startDate,
  quantity_details,
  handleDate,
  rack_details,
  selected_options,
  handleQuantity,
  sales_details,
  fields,
  handleChange,
  handleChangeType,
  handleRack,
  handleInput,
  hide,
  handleSelect,
  product,
  selling_price,
  errors,
  success,
  inputValues,
  dropdownData,
  dropdownDatas = [],
  handleSubmit,
  handleInputs,
  forms,
  handleSelectProductChange,
  getRack,
  selected_products,
  product_error,
  handleRemoveForm,
  handleSelectBoxChange,
  handleRemoveSelectBox,
  handleAddSelectBox,
  handlemrpChange,
  godown_error,
  mrp_error,
  handleInputChange,
  handlediscount,
  handleAddForm,
  canNfStockDown = false,
}) => {
  const today = new Date().toISOString().split('T')[0];
  const isNfStockDown = canNfStockDown && String(inputValues?.sales_type) === '2';
  const isDigital = String(inputValues?.sales_type) === '4';
  const hideCustomer =
    inputValues?.sales_type == 0 || isNfStockDown || isDigital;

  const handleProductSelect = (formIndex, productId) => {
    handleSelectProductChange(formIndex, productId);
    if (productId) {
      getRack(formIndex, productId);
    }
  };

  return (
    <React.Fragment>
      <div className="modal-overlay" />
      <div className="modal-wrapper" aria-modal aria-hidden tabIndex={-1} role="dialog">
        <div className="modal modalxl">
          <div className="modal-body">
            <div className="modal-header nf-modal-header mb-3">
              <div>
                <h5 className="text-center" id="staticBackdropLabel">
                  Non Fuel Product Direct Sales
                </h5>
                <p className="nf-modal-subtitle text-center">
                  Search products by name, assign storage, and complete sale details
                </p>
              </div>
              <button
                type="button"
                className="modal-close-button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={hide}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <form novalidate onSubmit={handleSubmit}>
              <p className="nf-section-label mb-2">Sale details</p>

              <div className="row g-3 justify-content-center mb-2">
                <div className="col-5">
                  <label className="col-form-label mx-5 font-weight-bolder">
                    Sales Type <sup className="star">*</sup>
                  </label>
                </div>
                <div className="col-6">
                  <div className="select-container">
                    <select
                      id=""
                      className="form-control"
                      name="sales_type"
                      value={inputValues.sales_type}
                      onChange={handleChangeType}
                    >
                      <option value="">Select</option>
                      <option value="0">Cash Sales</option>
                      <option value="1">Credit Sales</option>
                      {canNfStockDown ? <option value="2">NF Stock Down</option> : null}
                      <option value="4">Digital Payment Sales</option>
                    </select>
                  </div>
                  <div className="errorMsg">{errors.sales_type}</div>
                </div>
                <div className="col-1"></div>
              </div>

              {isDigital ? (
                <div className="row g-3 justify-content-center mb-2">
                  <div className="col-5">
                    <label className="col-form-label font-weight-bolder mx-5">
                      Digital Payment Type<sup className="star">*</sup>
                    </label>
                  </div>
                  <div className="col-6">
                    <div className="select-container">
                      <select
                        className="form-control"
                        name="digital_type"
                        value={inputValues.digital_type || ''}
                        onChange={handleChange}
                      >
                        <option value="">Select</option>
                        {dropdownDatas.map((item) => (
                          <option key={item.value} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="errorMsg">{errors.digital_type}</div>
                  </div>
                  <div className="col-1"></div>
                </div>
              ) : null}

              {!isDigital ? (
              <div className="row g-3 justify-content-center mb-2">
                <div className="col-5">
                  <label className="col-form-label font-weight-bolder mx-5">
                    Customer Name<sup className="star">*</sup>
                  </label>
                </div>
                <div className="col-6">
                  <div className="select-container">
                    <select
                      id=""
                      className="form-control"
                      name="customer_id"
                      value={inputValues.customer_id}
                      onChange={handleChange}
                      disabled={isNfStockDown}
                    >
                      {hideCustomer ? (
                        <option>{isNfStockDown ? '—' : 'Cash'}</option>
                      ) : (
                        <option value="">Select</option>
                      )}
                      {inputValues.sales_type == 1 &&
                        dropdownData.map((data) => {
                          return <option value={data[0]}>{data[1]}</option>;
                        })}
                    </select>
                  </div>
                  <div className="errorMsg">{errors.customer_id}</div>
                </div>
                <div className="col-1"></div>
              </div>
              ) : null}

              <div className="row g-3 justify-content-center mb-3">
                <div className="col-5">
                  <label className="col-form-label font-weight-bolder mx-5">Description</label>
                </div>
                <div className="col-6">
                  <input
                    type="text"
                    className="form-control"
                    name="note"
                    value={inputValues.note}
                    onChange={handle}
                    placeholder="Optional notes for this sale"
                  />
                </div>
                <div className="col-1"></div>
              </div>

              <p className="nf-section-label mb-2">Products</p>

              {forms.map((form, formIndex) => (
                <div key={formIndex} className="nf-product-card">
                  <div className="nf-product-card-header">
                    <span className="nf-product-badge">Product {formIndex + 1}</span>
                    {forms.length > 1 && (
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleRemoveForm(formIndex)}
                      >
                        Remove product
                      </button>
                    )}
                  </div>

                  <div className="row g-3 justify-content-center mb-2">
                    <div className="col-5">
                      <label className="col-form-label font-weight-bolder mx-5">
                        Product Name <sup className="star">*</sup>
                      </label>
                    </div>
                    <div className="col-6">
                      <NfProductSearchSelect
                        inputId={`nf-product-${formIndex}`}
                        options={getProductOptionsForForm(forms, formIndex, product)}
                        value={form.product_data}
                        onChange={(productId) => handleProductSelect(formIndex, productId)}
                        hasError={Boolean(product_error[formIndex])}
                        placeholder="Type to search product..."
                      />
                      <div className="errorMsg">{product_error[formIndex]}</div>
                    </div>
                  </div>

                  {form.rack?.length !== 0 && (
                    <>
                      {form.rack_data.map((option, optionIndex) => (
                        <div className="nf-rack-block" key={optionIndex}>
                          <div className="row g-3 justify-content-center mb-2">
                            <div className="col-5">
                              <label className="col-form-label font-weight-bolder mx-5">
                                Storage
                              </label>
                            </div>
                            <div className="col-6">
                              <div className="select-container">
                                <select
                                  className={'form-control rack' + formIndex}
                                  value={option?.rack_id}
                                  name="rack_id"
                                  onChange={(e) =>
                                    handleSelectBoxChange(
                                      formIndex,
                                      optionIndex,
                                      e.target.value,
                                      'rack_id'
                                    )
                                  }
                                >
                                  <option value="">Select a Rack</option>
                                  {form?.rack?.map((item) => {
                                    return (
                                      <option
                                        className={
                                          form.chek_rk.includes(item?.id) == true ? 'd-none' : ''
                                        }
                                        key={item.id}
                                        value={item?.id}
                                      >
                                        {item.rack_name + ' (' + item.stock + ')'}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>
                            </div>
                          </div>

                          <div className="row g-3 justify-content-center mb-2">
                            <div className="col-5">
                              <label className="col-form-label font-weight-bolder mx-5">
                                Quantity (No)
                              </label>
                            </div>
                            <div className="col-6">
                              <input
                                className="form-control hide-arrow"
                                type="number"
                                name="rack_q"
                                value={option.rack_q}
                                onKeyPress={(event) =>
                                  prevNonNumericalWithDec(event, event.target.value)
                                }
                                onChange={(e) =>
                                  handleSelectBoxChange(
                                    formIndex,
                                    optionIndex,
                                    e.target.value,
                                    'rack_q'
                                  )
                                }
                              />
                            </div>
                          </div>

                          <div className="nf-rack-actions">
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-secondary"
                              onClick={() => handleRemoveSelectBox(formIndex, optionIndex)}
                            >
                              Remove rack
                            </button>
                          </div>
                        </div>
                      ))}
                    </>
                  )}

                  {form.rack?.length !== 0 &&
                    form.rack_data.length != form.rack?.length && (
                      <div className="nf-rack-actions">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => handleAddSelectBox(formIndex)}
                        >
                          + Add rack
                        </button>
                      </div>
                    )}

                  <div className="errorMsg">{rack_error[formIndex]}</div>
                  <div className="errorMsg">{rack_error_single[formIndex]}</div>

                  {!isNfStockDown && (
                    <div className="row g-3 justify-content-center mb-2">
                      <div className="col-5">
                        <label className="col-form-label font-weight-bolder mx-5">Mrp</label>
                      </div>
                      <div className="col-5">
                        <input
                          className="form-control hide-arrow"
                          type="number"
                          value={form.mrp}
                          onChange={(e) => handlemrpChange(formIndex, e.target.value, e)}
                          onKeyPress={(event) =>
                            preventNonNumericalInput(event, event.target.value)
                          }
                        />
                        <div className="errorMsg">{mrp_error[formIndex]}</div>
                        {form.latest_purchase_price ? (
                          <small className="text-muted d-block mt-1">
                            Latest purchase: ₹{Number(form.latest_purchase_price).toFixed(2)}
                          </small>
                        ) : null}
                        {form.mrp_below_latest_cost && form.mrp_warning ? (
                          <div className="errorMsg mt-1" style={{ color: "#b45309" }}>
                            {form.mrp_warning}
                          </div>
                        ) : null}
                        <span className="amount-words"></span>
                      </div>
                    </div>
                  )}

                  <div className="row g-3 justify-content-center mb-2">
                    <div className="col-5">
                      <label className="col-form-label font-weight-bolder mx-5">
                        Sales from Godown Stock
                      </label>
                    </div>
                    <div className="col-6">
                      <input
                        type="number"
                        className="form-control hide-arrow"
                        value={form.sales_from_godown}
                        onChange={(e) => handleInputChange(formIndex, e.target.value)}
                        onKeyPress={(event) =>
                          prevNonNumericalWithDec(event, event.target.value)
                        }
                      />
                    </div>
                    {godown_error?.[formIndex] && (
                      <div className="errorMsg">{godown_error[formIndex]}</div>
                    )}
                  </div>
                </div>
              ))}

              <button
                type="button"
                className="btn btn-outline-primary nf-add-product-btn"
                onClick={handleAddForm}
              >
                + Add another product
              </button>

              <div className="nf-totals-section">
                <p className="nf-section-label mb-2">Summary</p>

                <div className="row g-3 justify-content-center mb-2">
                  <div className="col-5">
                    <label className="col-form-label font-weight-bolder mx-5">
                      Operational Date<sup className="star">*</sup>
                    </label>
                  </div>
                  <div className="col-6">
                    <input
                      type="date"
                      className="form-control"
                      name="op_date"
                      id={'m_op_date'}
                      value={
                        inputValues.op_date == undefined
                          ? localStorage.getItem('m_op_date') < startDate
                            ? startDate > today
                              ? ' '
                              : startDate
                            : localStorage.getItem('m_op_date')
                          : inputValues.op_date
                      }
                      min={startDate}
                      max={today}
                      onChange={handleDate}
                      disabled
                    />
                    <div className="errorMsg">{errors['op_date']}</div>
                  </div>
                  <div className="col-1"></div>
                </div>

                <div className="row g-3 justify-content-center mb-2">
                  <div className="col-5">
                    <label className="col-form-label font-weight-bolder mx-5">Sub Total</label>
                  </div>
                  <div className="col-6">
                    <input
                      type="text"
                      className="form-control"
                      name="subtotal"
                      value={inputValues.subtotal}
                      disabled
                    />
                  </div>
                  <div className="col-1"></div>
                </div>

                {!isNfStockDown && (
                  <div className="row g-3 justify-content-center mb-2">
                    <div className="col-5">
                      <label className="col-form-label font-weight-bolder mx-5">Discount</label>
                    </div>
                    <div className="col-6">
                      <input
                        type="number"
                        step="any"
                        className="form-control hide-arrow"
                        name="discount"
                        id="discount"
                        value={inputValues.discount}
                        onChange={handlediscount}
                        onKeyPress={(event) =>
                          preventNonNumericalInput(event, event.target.value)
                        }
                      />
                    </div>
                    <div className="col-1"></div>
                  </div>
                )}

                <div className="row g-3 justify-content-center mb-2">
                  <div className="col-5">
                    <label className="col-form-label font-weight-bolder mx-5">Total</label>
                  </div>
                  <div className="col-6">
                    <input
                      disabled
                      type="number"
                      className="form-control hide-arrow"
                      name="total"
                      value={inputValues.total}
                    />
                  </div>
                  <div className="col-1"></div>
                </div>

                <div className="row g-3 justify-content-center mb-2">
                  <div className="col-5">
                    <label className="col-form-label font-weight-bolder mx-5">
                      {isNfStockDown ? 'Amount' : 'Invoice Amount'}
                    </label>
                  </div>
                  <div className="col-6">
                    <input
                      disabled
                      type="number"
                      className="form-control hide-arrow"
                      name="amt_aft_discound"
                      value={inputValues.amt_aft_discound}
                    />
                  </div>
                  <div className="col-1"></div>
                </div>
              </div>

              <div className="modal-footer text-center">
                <a href="#" className="btn btn-danger w-auto" onClick={hide}>
                  Cancel
                </a>
                <button className="btn btn-primary w-auto" type="submit">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default NonFuelProductModal;
